import {
  computed,
  type ComputedRef,
} from 'vue';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import type {Page} from '@/ts/types/dto/interventions-dto';
import {useSessionId} from '@/ts/composables/stateful/use-session';

/** Resolves the current page and the next page ID within a session by session and page indices */
export function usePageId(sid: ComputedRef<UuidDTO>, pid: ComputedRef<number>): ({
  page: ComputedRef<Page | null>
  nextPageId: ComputedRef<number | null>
}) {
  const {session} = useSessionId(sid);
  // Returns null for an unknown session or an out-of-range page index instead of
  // throwing — callers (and route guards) must handle the null case (IPD-2751).
  const page = computed<Page | null>(() => session.value?.pages[pid.value - 1] ?? null);
  const nextPageId = computed(() => {
    if (session.value && session.value.pages.length > pid.value) {
      return pid.value + 1;
    }
    return null;
  });
 return {page, nextPageId};
}
